import React from 'react';
import ReactDOM from 'react-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ServiceLegal from './serviceLegal'
import ProtectionLegal from './protectionLegal'

class LegalDialog extends React.Component {
    constructor(props) {
        super(props);
        this.onScroll = this.onScroll.bind(this);
        this.state = {disabled: true}
    }

    handleClose = () => {
        this.content.removeEventListener('scroll', this.onScroll, false);
        this.props.handleClose();
    };

    handleOpen = () => {
        const o = this.content;
        const totalHeight = Math.ceil(o.offsetHeight + o.scrollTop);
        if (totalHeight === o.scrollHeight) {
            const {legal} = this.props;
            this.props.onScrollEnd(legal)
        } else {
            this.content.addEventListener('scroll', this.onScroll, false);
        }
    };

    onScroll() {
        const o = this.content;
        const totalHeight = Math.ceil(o.offsetHeight + o.scrollTop);
        if (totalHeight === o.scrollHeight) {
            const {legal} = this.props;
            this.props.onScrollEnd(legal)
        }
    }

    render() {
        const {legal, pack, serviceActionDisabled, protectionActionDisabled} = this.props;
        const title =
            legal === 'service'
                ? "Όροι Xρήσης Yπηρεσίας"
                : "Όροι Προστασίας Προσωπικών Δεδομένων";

        
        const content =
            legal === 'service'
                ? (<ServiceLegal pack={pack}/>)
                : (<ProtectionLegal pack={pack}/>);

        const actionDenyLabel =
            legal === 'service'
                ? "ΔΕΝ ΣΥΜΦΩΝΩ"
                : "ΔΕΝ ΣΥΝΑΙΝΩ";

        const actionOkLabel =
            legal === 'service'
                ? "ΣΥΜΦΩΝΩ"
                : "ΣΥΝΑΙΝΩ";

        const actionDisabled =
            legal === 'service'
                ? serviceActionDisabled
                : protectionActionDisabled;

        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onEnter={this.handleOpen}
                    onClose={this.handleClose}
                    scroll={'paper'}
                    aria-labelledby="scroll-dialog-title"
                >
                    <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
                    <DialogContent ref={ref => {
                        this.content = ReactDOM.findDOMNode(ref);
                    }}>
                        {content}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.props.actionHandler(false)}
                            color="primary"
                            disabled={actionDisabled}
                        >
                            {actionDenyLabel}
                        </Button>
                        <Button
                            onClick={this.props.actionHandler(true)}
                            color="primary"
                            disabled={actionDisabled}
                        >
                            {actionOkLabel || "ΣΥΜΦΩΝΩ"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default LegalDialog;
